export type DataObjectValueType = unknown;

export type DataObject = { [key in string]?: DataObjectValueType };

export type Data = DataObject | DataObjectValueType | null;

export interface ExpEvalRequest {
  expression: string;
  data: Data;
  variables: DataObject;
}

export interface ExpEvalResult {
  value: Data;
}

export enum ExpressionLanguage {
  SPEL = 'SPEL',
  JEXL = 'JEXL',
}

export const SIZE_SUFFIX = '.length';
